var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconOverseasHotel(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.738 7c.1.5.223.888.347 1.137v1.35C2.877 9.364 1.116 7.514 1.116 5.25 1.116 2.913 3.014 1 5.333 1 7.653 1 9.55 2.913 9.55 5.25c0 .25-.024.513-.062.75H8.471c.062-.237.087-.487.087-.75s-.025-.513-.087-.75H7.045c.012.25.025.5.025.75s-.013.5-.025.75l-.471 1H4.738zm2.195-3.5H8.05a3.312 3.312 0 00-1.44-1.237c.15.375.249.787.323 1.237zm-1.004 0c-.174-.9-.447-1.4-.596-1.487-.149.087-.421.587-.595 1.487h1.19zm-3.82 1.75c0 .263.024.513.086.75h1.427c-.013-.25-.025-.5-.025-.75s.012-.5.025-.75H2.195a2.958 2.958 0 00-.087.75zM3.732 7H2.617c.347.537.843.975 1.439 1.238A6.006 6.006 0 013.733 7zM2.617 3.5h1.116c.075-.45.186-.862.323-1.237-.596.262-1.092.7-1.439 1.237zm1.997 1c-.013.237-.025.487-.025.75s.012.513.025.75h1.439c.012-.237.024-.487.024-.75s-.012-.513-.024-.75h-1.44zm8.41 9.5H7.07V9h5.953v5zm.991-5v5h.993v1H5.085v-1h.992V8h1.489V7h4.961v1h1.488v1zm-1.984 2h-1.488v-1h1.488v1zm-3.97 0h1.49v-1H8.06v1zm3.97 2h-1.488v-1h1.488v1zm-3.97 0h1.49v-1H8.06v1z",
    fill: "#6D6D6D"
  })));
}

export default SvgIconOverseasHotel;